const CHECK_TIME_ACTIONS = {
  //check time
  GET_CHECK_TIME_REQUEST: "GET_CHECK_TIME_REQUEST",
  GET_CHECK_TIME_REQUEST_SUCCESS: "GET_CHECK_TIME_REQUEST_SUCCESS",
  GET_CHECK_TIME_REQUEST_FAIL: "GET_CHECK_TIME_REQUEST_FAIL",
  //GET_KEY_TO_CHECK_TIME_REQUEST_SUCCESS
  GET_KEY_TO_CHECK_TIME_REQUEST_SUCCESS:
    "GET_KEY_TO_CHECK_TIME_REQUEST_SUCCESS",
  GET_KEY_TO_CHECK_TIME_REQUEST: "GET_KEY_TO_CHECK_TIME_REQUEST",
  GET_KEY_TO_CHECK_TIME_REQUEST_FAIL: "GET_KEY_TO_CHECK_TIME_REQUEST_FAIL",
  GET_CHECK_OUT: "GET_CHECK_OUT",
  GET_CHECK_IN: "GET_CHECK_IN",
};
export default CHECK_TIME_ACTIONS;
